<template>
  <div class="bg_all">
    <div class="face_header">
      <div class="face_header_con">
        <p class="face_header_lf">全能考试系统</p>
      </div>
    </div>
    <div class="mimcz_con">
      <div class="mimcz">
        <h1 class="mimcz_tit">密码重置</h1>
        <ul class="cz">
          <li>
            <p style="font-size:20px;padding:20px;">
              考试系统的账户名称和密码由您的管理老师统一下发；如您已经忘记了账户名称或密码，请联系您的管理老师进行重置。
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ResetPassword"
};
</script>

<style scoped></style>
